import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Api, ApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Button, TextField, Card } from "../../components/ui";
import "./auth.css";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    if (password !== confirm) {
      setError("Passwords don't match");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const resp = await Api.register(name, email, password, phone);
      await login(resp.token);
      navigate("/plan", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Registration failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="tg-auth-screen">
      <Card className="tg-auth-card">
        <h1 style={{ fontSize: 22 }}>Create your account</h1>

        <form onSubmit={submit} className="tg-auth-form" style={{ marginTop: 18 }}>
          <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} required />
          <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <TextField label="Phone (for SMS alerts)" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <TextField
            label="Confirm password"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
          {error && <p className="tg-auth-error">{error}</p>}
          <Button type="submit" fullWidth disabled={loading}>
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>

        <div style={{ marginTop: 18, textAlign: "center" }}>
          <Link to="/login" className="tg-link">
            Already have an account? Log in
          </Link>
        </div>
      </Card>
    </div>
  );
}
